import { render, staticRenderFns } from "./ShowEventConferenceTab.vue?vue&type=template&id=56e66e4f&scoped=true"
import script from "./ShowEventConferenceTab.vue?vue&type=script&lang=js"
export * from "./ShowEventConferenceTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e66e4f",
  null
  
)

export default component.exports